
import { Box, Typography } from '@mui/material'
import { DensityStyleTypes, Deals } from '../../../../types'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'

interface RenderProbabilityProps {
  params: { row: GridRenderCellParams<Deals, object> }
  densityStyles: DensityStyleTypes
}

const RenderProbabilityCell: React.FC<RenderProbabilityProps> = ({ params, densityStyles }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
      }}
    >
      {<Typography sx={{ fontSize: 14 }}>{(params as any)?.value ? `${((params as any)?.value ?? 0).toFixed(2)} %` : 0}</Typography>}
    </Box>
  )
}
export default RenderProbabilityCell
